import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
//primereact
import { Menu } from "primereact/menu";
//services
import { getTemporaryUrl } from "../../services/File/getTemporaryUrl";
//modals
import Modal from "../modal/Modal";
import { getAdminTemporaryUrl } from "../../services/File/getAdminTemporaryUrl";

const CardDocument = ({
  key,
  size,
  date,
  file,
  type,
  idDoc,
  folder,
  actions,
  hasLink,
  isAdmin,
  onClick,
  preview,
  fileName,
  className,
  clickSign,
  completed,
  doNotDelete,
  description,
  hasViewFile,
  editFunction,
  deleteFunction,
  downloadFunction,
  requiredComplete,
  descriptionCompleted,
}) => {
  const menu = useRef(null);
  const [icon, setIcon] = useState(null);
  const [iconColor, setIconColor] = useState(null);
  const [visible, setVisible] = useState(false);
  const [previewDoc, setPreviewDoc] = useState([]);

  useEffect(() => {
    handleType(type);
  }, [type]);

  const handleType = (type) => {
    if (type === "pdf") {
      setIcon("fa-file-pdf");
      setIconColor("text-danger");
    } else if (type === "xlsx" || type === "xls") {
      setIcon("fa-file-excel");
      setIconColor("text-green");
    } else if (type === "document" || type === "docx" || type === "doc") {
      setIcon("fa-file-word");
      setIconColor("text-info");
    } else if (
      type === "png" ||
      type === "jpg" ||
      type === "jpeg" ||
      type === "webp"
    ) {
      setIcon("fa-image");
    } else if (type === "folder") {
      setIcon("fa-folder");
    } else if (type === "add") {
      setIcon("fa-plus");
      setIconColor();
    } else if (type === "variables") {
      setIcon("fa-at");
      setIconColor();
    } else {
      setIcon("fa-file");
    }
  };

  const viewFile = async (id, typeFile, name) => {
    const notification = toast.loading("Por favor aguarde, carregando...");
    // console.log(isAdmin)
    const newDocUrl = isAdmin ?  await getAdminTemporaryUrl(id) : await getTemporaryUrl(id);
    // console.log(newDocUrl)
    const urlNewFile = newDocUrl.url;
    // console.log(typeFile)

    if (urlNewFile && typeFile !== "zip") {
      setPreviewDoc([
        {
          uri: urlNewFile,
          fileType: typeFile,
          fileName: name,
        },
      ]);
      setVisible(true);
      toast.update(notification, {
        render: "Documento Carregado!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } else {
      toast.update(notification, {
        render: "Não foi possível visualizar o arquivo, faça o download!",
        autoClose: 1000,
        theme: "colored",
        type: "warning",
        isLoading: false,
      });
    }
  };

  const downloadFile = async (id) => {
    const notification = toast.loading("Preparando seu download...");
    try {
      const response = isAdmin ?  await getAdminTemporaryUrl(id) : await getTemporaryUrl(id);
      // console.log(response);

      const extractFileName = (url) => {
        const matches = url.match(/\/([^\/?#]+)[^\/]*$/);
        if (matches && matches.length > 1) {
          return matches[1];
        }
        return null;
      };

      const fileName = extractFileName(response.url);

      function downloadPDF(url) {
        fetch(url)
          .then((response) => response.blob())
          .then((blob) => {
            const blobURL = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobURL;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch((error) => {
            console.error("Erro ao fazer o download do PDF:", error);
          });
      }

      downloadPDF(response.url);

      toast.update(notification, {
        render: "Download concluído!",
        autoClose: 5000,
        type: "success",
        isLoading: false,
      });
      return response.url;
    } catch (error) {
      // console.log(error);
      toast.update(notification, {
        render: "Oops, algo deu errado!",
        autoClose: 5000,
        type: "error",
        isLoading: false,
      });
      return null;
    }
  };

  const items = [
    {
      label: "Ações",
      items: [
        hasViewFile && {
          label: "Visualizar",
          icon: "fa-solid fa-eye",
          command: () => viewFile(idDoc, type, fileName),
        },
        hasLink && {
          label: "Download",
          icon: "fa-solid fa-download",
          command: () =>
            downloadFunction
              ? downloadFunction(idDoc, fileName)
              : downloadFile(idDoc),
        },
        clickSign && {
          label: "Enviar para ClickSign",
          icon: "fa-solid fa-file-signature",
          command: () => clickSign(file, fileName, idDoc),
        },
        requiredComplete
          ? {
            label: "Alterar",
            icon: "fa-solid fa-pencil",
            command: () => editFunction(),
          }
          : !doNotDelete && {
            label: "Deletar",
            icon: "fa-solid fa-trash",
            command: () => deleteFunction(idDoc),
          },
      ].filter(Boolean),
    },
  ];

  return (
    <div
      key={key}
      className={`${className ? className : "col-xl-3 col-md-6 col-sm-12"
        } pb-4 card-animation`}
      style={{ cursor: "pointer" }}
    >
      <div
        className={`card h-100 position-relative ${completed && "bg-success text-white"
          }`}
      >
        <div className="p-4">
          {folder ? (
            <div className="col-md-12 text-end opacity-0">
              <h4>
                <i className="fa-solid fa-download icon-download"></i>
              </h4>
            </div>
          ) : actions ? (
            <div className="d-flex">
              {requiredComplete && (
                <h1 className="col-md-6 d-flex justify-content-start">
                  <i
                    className="fa-solid fa-check"
                    style={{ color: "#23e15c" }}
                  ></i>
                </h1>
              )}
              <div
                className={`${requiredComplete ? "col-md-6" : "col-md-12"
                  } d-flex justify-content-end opacity-75`}
              >
                <Menu model={items} popup ref={menu} id="popup_menu" />
                <h4
                  className="text-center icon-dowload"
                  style={{ width: "20%" }}
                  onClick={(event) => menu.current.toggle(event)}
                >
                  <i
                    className="fa-solid fa-ellipsis-vertical "
                    aria-controls="popup_menu"
                  ></i>
                </h4>
              </div>
            </div>
          ) : (
            <div style={{ height: 26 }}></div>
          )}
          <div onClick={onClick}>
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "100px", maxHeight: "100px" }}
            >
              {preview ? (
                <img src={preview} alt="preview" width={150} />
              ) : (
                <div className="text-center">
                  {completed ? (
                    <h1 style={{ position: "absolute", right: 20, left: 10 }}>
                      <i className="fa-solid fa-check icon-modal"></i>
                    </h1>
                  ) : (
                    <h1>
                      <i className={`fa ${icon} fa-2xl ${iconColor}`}></i>
                    </h1>
                  )}
                </div>
              )}
            </div>
            <hr className="mt-4" />
            <div>
              <h5 className={`m-b-5 ${!completed && "text-muted"} text-center`}>
                {!completed ? description : descriptionCompleted}
              </h5>
              <h6 className={`m-b-5 ${!completed && "text-muted"} text-center`}>
                {fileName}
              </h6>
              <div className="col-md-12 pt-3 d-flex justify-content-between">
                <div className="col-md-6">
                  <small className="">{size}</small>
                </div>
                <div className="col-md-6 text-end">
                  <span className="date text-muted">{date}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        dynamicTitle="Visualização Prévia"
        visible={visible}
        style={{ width: "80vw" }}
        onHide={() => setVisible(false)}
      >
        {previewDoc && (
          <DocViewer
            documents={previewDoc}
            pluginRenderers={DocViewerRenderers}
            className="mb-3"
            style={{ height: "75vh" }}
          />
        )}
      </Modal>
    </div>
  );
};

export default CardDocument;